import store from 'Store'

const state = {
  states: []
}

const getters = {
  getState (state) {
    return state
  },
  stateByName (state, name) {
    if (state.states !== undefined) {
      const theState = state.states.find(item => item.name === name)
      return theState
    }
  }
}

const actions = {
  fetchData ({ commit }) {
    const currentScene = store.getters['scenes/getCurrentScene']
    return commit('setState', currentScene)
  }
}

const mutations = {
  setState (state, data) {
    state.states = data.states
  },
  recurseBasedOn (state, item) {
    if (item !== undefined && item.basedon !== undefined && state.states !== undefined) {
      const basedonState = state.states.find(s => s.name === item.basedon)
      item.basedon = basedonState
      mutations.recurseBasedOn(state, item.basedon)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
